import React, { useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';

/**
 * ProfileSync - Legacy Component (Now Optional)
 * 
 * With Supabase migration, profile creation is now handled automatically
 * by the backend via Lazy Profile Creation in auth_middleware.py.
 * 
 * This component is kept for backward compatibility and debugging,
 * but it no longer creates profiles - that's done automatically on first API call.
 */
const ProfileSync: React.FC = () => {
  const { isSignedIn, user } = useAuth();

  useEffect(() => {
    if (isSignedIn && user) {
      // Profile will be automatically created by backend on first authenticated API call
      // via auth_middleware.py -> ensure_profile_exists()
      console.debug('✅ User authenticated:', user.userId);
      console.debug('📋 Profile will be created automatically by backend if needed');
    }
  }, [isSignedIn, user?.userId]);

  // This component doesn't render anything visible
  // Profile creation is now handled by backend
  if (process.env.NODE_ENV === 'development') {
    // Show status in development for debugging
    return (
      <div className="fixed bottom-4 right-4 z-[10001] bg-gray-800 text-white px-3 py-2 rounded text-xs opacity-50">
        Auth: {isSignedIn ? 'Signed In' : 'Anonymous'}
      </div>
    );
  }

  return null;
};

export default ProfileSync;
